import { createAsyncThunk } from '@reduxjs/toolkit'
import TimelineWebAPI from '@api/timeline_web_api.js'
import MarkerWebAPI from '@api/marker_web_api.js'
import TimespanWebAPI from '@api/timespan_web_api.js'

import { serializableError } from '@utils/serializable_error.ts'
import {
  handleCreateMarkerSuccess,
  handleUpdateMarkerSuccess,
  handleDeleteMarkerSuccess,
  handleCreateTimespanSuccess,
  handleUpdateTimespanSuccess,
  handleDeleteTimespanSuccess,
  handleUpdateTimelineSuccess,
} from './ServerActions.js'

export const saveEntity = createAsyncThunk('entities/saveEntity', async (obj, thunkAPI) => {
  const { dispatch, rejectWithValue } = thunkAPI
  const { id, type, attributes } = obj
  const idString = id.toString()
  const lowerCaseType = type.toLowerCase()
  try {
    let response
    switch (lowerCaseType) {
      // marker saving
      case 'marker':
        if (idString === '-1' || idString === '0') {
          response = await MarkerWebAPI.createMarker(attributes)
          dispatch(handleCreateMarkerSuccess(response))
        } else {
          response = await MarkerWebAPI.updateMarker(attributes)
          dispatch(handleUpdateMarkerSuccess(idString, response))
        }
        break

      // timespan saving
      case 'timespan':
        if (idString === '-1' || idString === '0') {
          response = await TimespanWebAPI.createTimespan(attributes)
          dispatch(handleCreateTimespanSuccess(response))
        } else {
          response = await TimespanWebAPI.updateTimespan(attributes)
          dispatch(handleUpdateTimespanSuccess(idString, response))
        }
        break

      // timeline saving
      case 'timeline':
        if (idString === '-1' || idString === '0') {
          throw new Error('Timeline creation using entity saver is deprecated. Use Timeline form feature instead')
        } else {
          response = await TimelineWebAPI.updateTimeline(attributes)
          dispatch(handleUpdateTimelineSuccess(idString, response))
        }
        break

      default:
        console.error('saveEntity: Unknown type: ', lowerCaseType)
    }
  } catch (error) {
    return rejectWithValue(serializableError(error))
  }
})

export const deleteEntity = createAsyncThunk('entities/deleteEntity', async (obj, thunkAPI) => {
  const { dispatch, rejectWithValue } = thunkAPI
  const { id, type, attributes } = obj
  const idString = id.toString()
  const lowerCaseType = type.toLowerCase()
  try {
    let response
    switch (lowerCaseType) {
      // marker deletion
      case 'marker':
        response = await MarkerWebAPI.deleteMarker(attributes)
        dispatch(handleDeleteMarkerSuccess(idString, response))
        break

      // timespan deletion
      case 'timespan':
        response = await TimespanWebAPI.deleteTimespan(attributes)
        dispatch(handleDeleteTimespanSuccess(idString, response))
        break

      default:
        console.error('deleteEntity: Unknown type: ', lowerCaseType)
    }
  } catch (error) {
    console.log('deleteEntity error', error)
    return rejectWithValue(serializableError(error))
  }
})
